<template>
    <div class="refundRebate">
        <Header :pageTitle="serviceType" />
        <div class="content">
            <!-- 退货商品 -->
            <div class="content-item efundGoods">
                <div class="title">
                    <span>{{ goodsObj.afterType | titleFilter }}商品</span>
                </div>
                <div class="goods-box">
                    <div class="left">
                        <img
                            :src="
                                goodsObjInfo.albumPics
                                    ? $global.imgUrl + goodsObjInfo.albumPics.split(',')[0]
                                    : require('@/assets/img/mobile-img/zz_default.png')
                            "
                            alt=""
                        />
                    </div>
                    <div class="right">
                        <div class="title">
                            <span>{{ goodsObjInfo.goodsName }}</span>
                        </div>
                        <div class="contentTxt">
                            <span v-html="goodsObjInfo.specificationsValueOne"></span>
                            <span v-html="goodsObjInfo.specificationsValueTwo"></span>
                        </div>
                    </div>
                </div>

                <div class="refund-num item" v-if="goodsObj.afterType != 3">
                    <div class="left">{{ goodsObj.afterType | titleFilter }}数量</div>
                    <div class="right">
                        <van-stepper
                            :disabled="goodsObj.afterType == 3"
                            v-model="goodsObjInfo.saleNum"
                            :max="goodsObjInfo.saleNumMax"
                            :min="saleNumMin"
                        />
                    </div>
                </div>

                <div class="participant item" v-if="goodsObj.goodsType == 2">
                    <div class="left">参会人</div>
                    <div class="right">
                        <van-cell is-link @click="participant">
                            <span v-if="nameList.length">{{ nameList.join() }}</span>
                            <span v-else style="color: #b2b2b2">请选择参会人</span>
                        </van-cell>
                        <van-popup
                            class="popuptk"
                            position="bottom"
                            :style="{ height: '60%' }"
                            v-model="meetAttendeePopupShow"
                        >
                            <div
                                style="
                                    padding: 0 26px;
                                    height: 60px;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    font-size: 17px;
                                    font-weight: 500;
                                    border-bottom: 1px solid #eeeeee;
                                "
                            >
                                <div style="font-size: 15px">选择参会人</div>
                                <van-icon
                                    style="width: 13px; height: 13px"
                                    name="cross"
                                    @click="() => (meetAttendeePopupShow = false)"
                                />
                            </div>
                            <van-checkbox-group v-model="participantListChange">
                                <van-checkbox
                                    v-for="(value, index) in goodsObjInfo.participantList"
                                    :key="index"
                                    label-position="left"
                                    checked-color="#4A79F1"
                                    :name="value.id"
                                >
                                    {{ value.name }}
                                </van-checkbox>
                            </van-checkbox-group>
                            <div
                                style="
                                    height: 55px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                "
                            >
                                <van-button
                                    :loading="submitloading"
                                    style="width: 80%; border-radius: 22px; height: 44px"
                                    type="info"
                                    @click="confirm(goodsObjInfo)"
                                    >确定</van-button
                                >
                            </div>
                        </van-popup>
                    </div>
                </div>

                <div class="item money" v-if="goodsObj.afterType != 1">
                    <div class="left">退款金额</div>
                    <div class="right">
                        <van-field
                            @input="moneyInput(goodsObjInfo)"
                            v-model="goodsObjInfo.saleAmount"
                            :disabled="goodsObj.status == 3"
                            type="number"
                            label-width="5"
                            label="￥"
                            placeholder=""
                        />
                    </div>
                    <div class="left"></div>
                    <!-- ，含运费¥0.00 -->
                    <div
                        style="
                            width: calc(95% - 80px);
                            margin-top: 10px;
                            font-size: 13px;
                            color: #b2b2b2;
                        "
                    >
                        最多¥{{ parseInt(`${goodsObjInfo.moneyMax * 100}`) / 100 }}
                    </div>
                </div>
            </div>
            <!-- 服务类型申请原因 -->
            <div class="content-item" style="padding: 0;">
                <van-form ref="formRef">
                    <van-field label="服务类型" v-model="serviceType" readonly />
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="reasonApplyingText"
                        label="退款原因"
                        placeholder="请选择"
                        @click="showReasonApplying = true"
                        :rules="[{ required: true, message: '请选择退款原因' }]"
                    />
                    <van-popup v-model="showReasonApplying" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="afterSalesReasonTypeEnums"
                            @confirm="reasonApplyingConfirm"
                            @cancel="showReasonApplying = false"
                            value-key="name"
                        />
                    </van-popup>
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="refundChannelText"
                        label="退款方式"
                        placeholder="请选择"
                        @click="showRefundChannel = true"
                        :rules="[{ required: true, message: '请选择退款方式' }]"
                    />
                    <van-popup v-model="showRefundChannel" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="refundChannelEnums"
                            @confirm="refundChannelConfirm"
                            @cancel="showRefundChannel = false"
                            value-key="label"
                        />
                    </van-popup>
                    <template v-if="model.refundChannel === 'OFFLINE'">
                        <van-field
                            v-model="model.customerAccountName"
                            name="customerAccountName"
                            label="收款人"
                            placeholder="请输入"
                            :rules="[{ required: true, message: '请输入收款人' }, { pattern: /^.{0,50}$/, message: '收款人限制50个字' }]"
                        />
                        <van-field
                            v-model="model.customerAccountNo"
                            name="customerAccountNo"
                            label="收款账户"
                            placeholder="请输入"
                            :rules="[{ required: true, message: '请输入收款账户' }, { pattern: /^.{0,50}$/, message: '收款账户限制50个字' }]"
                        />
                        <van-field
                            v-model="model.customerBankName"
                            name="customerBankName"
                            label="开户银行"
                            placeholder="请输入"
                            :rules="[{ required: true, message: '请输入开户银行' }]"
                        />
                    </template>
                </van-form>
            </div>
            <!-- 问题描述 -->
            <div class="content-item">
                <div class="title">
                    <span>问题描述</span>
                </div>
                <van-field
                    class="describe-box"
                    type="textarea"
                    :show-word-limit="true"
                    autosize
                    maxlength="500"
                    v-model="describe"
                    placeholder="请填写问题描述"
                    rows="4"
                />
                <!--  -->
                <van-uploader
                    :upload-icon="require('@/assets/mylogin/uploadPictures.png')"
                    style="margin-top: 10px"
                    v-model="preivewFileList"
                    :max-count="5"
                    :max-size="2 * 1024 * 1024"
                    :before-read="beforeRead"
                    :after-read="clzpAfterRead"
                    @delete="toDeleteFile"
                    @oversize="onOversize"
                />
            </div>
        </div>
        <div class="footer">
            <div class="content-item">
                <van-button
                    :loading="submitloading"
                    style="width: 80%; border-radius: 22px; height: 44px"
                    type="info"
                    @click="submitApplications"
                    >提交申请</van-button
                >
            </div>
        </div>
        <TipsDialog
            :showDialog="showDialog"
            @dialogCancel="showDialog = false"
            @dialogConfirm="dialogConfirm"
        >
            <p>{{ tipsDialogText }}</p>
        </TipsDialog>
    </div>
</template>
<script>
import { Toast } from "vant";
import Header from "@/views/mobileView/components/header/index.vue";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
export default {
    components: {
        Header,
        TipsDialog,
    },
    computed: {
        serviceType() {
            let obj = {
                1: "换货",
                2: "退货退款",
                3: "仅退款",
            };
            return obj[this.goodsObj.afterType];
        },
    },
    watch: {
        "goodsObjInfo.saleNum": {
            handler(newValue) {
                let saleAmount = parseInt(`${newValue * this.goodsObjInfo.unitPrice * 100}`) / 100;
                let moneyMax = this.goodsObjInfo.saleNum * this.goodsObjInfo.unitPrice; // 最大钱
                this.goodsObjInfo.saleAmount = isNaN(saleAmount) ? 0 : saleAmount;
                this.goodsObjInfo.moneyMax = isNaN(moneyMax) ? 0 : moneyMax;
            },
            immediate: true,
            deep: true,
        },
        newParticipantListChange: {
            handler(newValue) {
                if (newValue.length) {
                    this.goodsObjInfo.saleNum = newValue.length;
                    this.saleNumMin = newValue.length;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    data() {
        return {
            saleNumMin: 1,
            saleAmountAll: "",
            radio: "",
            value: 1,
            meetAttendeePopupShow: false,
            participantListChange: [], // 选择的参会人
            newParticipantListChange: [], // 确认选择的人
            nameList: [],
            participantListChangeObj: [],
            describe: "", // 描述
            fileList: [],
            preivewFileList: [],
            goodsObj: {
                id: "",
                goodsType: "",
                status: "",
                afterType: "",
            },
            order: {},
            // goodsDetial:{}
            goodsList: [],
            goodsObjInfo: {},
            submitloading: false,
            showDialog: false,
            tipsDialogText: "",
            showReasonApplying: false,
            reasonApplyingText: "",
            afterSalesReasonTypeEnums: [], // 退款原因
            showRefundChannel: false,
            refundChannelText: "",
            refundChannelEnums: [
                { label: '线上退款', value: 'ONLINE' },
                { label: '线下退款', value: 'OFFLINE' },
            ], // 退款方式选项
            model: {},
        };
    },
    filters: {
        titleFilter(value) {
            switch (Number(value)) {
                case 1:
                    return "换货";
                case 2:
                    return "退货";
                case 3:
                    return "退款";
            }
        },
    },
    async created() {
        this.goodsObj = this.$route.query;
        const res = await this.$apis.afterSalesOrder.getBeforeSubmitDetail({
            orderGoodsId: this.goodsObj.id,
        });
        this.afterSalesReasonTypeEnums = res.data.afterSalesReasonTypeEnums;
        this.goodsList = [res.data.goods];
        this.goodsObjInfo = res.data.goods;
        this.order = res.data.order;
        this.goodsObjInfo.saleNumMax = this.goodsObjInfo.saleNum; // 最大数量
        // this.goodsObjInfo.moneyMax = this.goodsObjInfo.saleNumMax * this.goodsObjInfo.unitPrice // 最大钱
        this.goodsObjInfo.unitPrice = this.goodsObjInfo.saleAmount; // 单价
        this.goodsObjInfo.participantList = [];
        let res1 = await this.$apis.myServe.meetingMemberInfoInOrders({
            payBatchId: this.goodsObjInfo.payBatchId,
        });
        this.goodsObjInfo.participantList = res1.data;
    },
    methods: {
        // 获取参会人员
        // 参会人事件
        participant() {
            this.meetAttendeePopupShow = true;
            this.participantListChange = JSON.parse(JSON.stringify(this.newParticipantListChange));
        },
        confirm(item) {
            this.nameList = [];
            this.participantListChangeObj = [];
            this.newParticipantListChange = JSON.parse(JSON.stringify(this.participantListChange));
            this.newParticipantListChange.forEach((val) => {
                item.participantList.forEach((value) => {
                    if (val === value.id) {
                        this.nameList.push(value.name);
                        this.participantListChangeObj.push(value);
                    }
                });
            });
            this.meetAttendeePopupShow = false;
        },
        reasonApplyingConfirm({code, name}) {
            this.model.reason = code;
            this.reasonApplyingText = name;
            this.showReasonApplying = false;
        },
        refundChannelConfirm({ value, label }) {
            this.model.refundChannel = value;
            this.refundChannelText = label;
            this.showRefundChannel = false;
        },
        // 上传文件
        async clzpAfterRead(file, { index }) {
            const _this = this;
            file.status = "uploading";
            file.message = "上传中...";
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await _this.$apis.myServe.uploadFileMannual(formData);
            if (res.resultCode == 200) {
                file.status = "done";
                file.message = "上传成功";
                this.fileList[index] = res.content.url;
                this.preivewFileList[index].url = this.$global.imgUrl + res.content.url;
            } else {
                file.status = "failed";
                file.message = "failed";
                _this.$toast(res.resultDesc);
            }
        },
        toDeleteFile(_, { index }) {
            this.fileList.splice(index, 1);
        },
        onOversize() {
            this.$toast("图片大小不能超过2MB");
        },
        // 退款金额最大值校验
        moneyInput(item) {
            if (item.saleAmount > item.moneyMax) {
                this.goodsObjInfo.saleAmount = item.moneyMax;
            }
            // if(item.saleAmount == 0){
            //   this.goodsObjInfo.saleAmount = item.unitPrice
            // }
        },
        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                Toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },
        // 提交申请
        async submitApplications() {
            if (!this.goodsList[0].saleAmount || this.goodsList[0].saleAmount == 0) {
                Toast.fail("请输入退款金额且不能为0");
                return;
            }
            await this.$refs.formRef.validate()
            if (this.goodsObj.goodsType === "2") {
                if (this.newParticipantListChange.length === 0) {
                    Toast.fail("请选择参会人");
                    return;
                }
                this.tipsDialogText = "退款成功后，您报名的会议权益将取消，请确认操作";
                this.showDialog = true;
            } else if (this.goodsObj.goodsType === "3") {
                this.tipsDialogText = "退款成功后，您报名的课程权益将取消，请确认操作";
                this.showDialog = true;
            } else {
                this.dialogConfirm();
            }
        },
        async dialogConfirm() {
            let mediaPaths = this.fileList.join();
            let obj = {
                ...this.model,
                orderGoodsId: this.goodsObj.id, // 订单商品id
                problemDesc: this.describe, // 问题描述
                // refundAmount: this.goodsList[0].saleAmount, // 退款金额
                returnCount: this.goodsList[0].saleNum, // 退还数量
                type: this.goodsObj.afterType, // 售后类型
                mediaPaths, // 图片
                subOrderId: this.order.id,
                createTimeTemp: this.order.createTime,
            };
            if (obj.refundChannel === 'ONLINE') {
                delete obj.customerAccountName;
                delete obj.customerAccountNo;
                delete obj.customerBankName;
            }
            if (this.goodsObj.goodsType === "2") {
                obj.exField = JSON.stringify(this.participantListChangeObj);
            }
            if (this.goodsObj.afterType != 1) {
                obj.refundAmount = this.goodsList[0].saleAmount;
            }
            this.submitloading = true;
            const res = await this.$apis.afterSalesOrder.submitOrder(obj);
            if (res.resultCode == 200) {
                this.submitloading = false;
                this.$router.replace({
                    path: "/orderDetails",
                    query: {
                        id: this.goodsList[0].orderId,
                    },
                });
            } else {
                this.submitloading = false;
                this.$toast(res.resultDesc);
            }
        },
    },
};
</script>
<style lang="scss">
html,
body {
    height: 100%;
    background: #f5f5f5;
}

.refundRebate {
    height: 100%;
    position: relative;
    padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
    padding-top: calc(env(safe-area-inset-top) + 44px) !important;

    .van-uploader__upload {
        i {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .content {
        // height: calc(100% - 55px);
        overflow: auto;
        padding: 0 12px 60px;

        .popuptk {
            border: 1px solid transparent;
            border: none;
            border: 5;
            border-radius: 16px 16px 0px 0px;

            .van-radio-group {
                padding: 0 26px;
                margin-top: 24px;
                height: calc(100% - 148px);
                overflow: auto;

                .van-radio {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    margin-bottom: 30px;
                    // color: #4A79F1;
                }
            }

            .van-checkbox-group {
                padding: 0 26px;
                margin-top: 24px;
                height: calc(100% - 148px);

                .van-checkbox {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    margin-bottom: 30px;
                }
            }
        }

        .content-item {
            width: calc(100% - 1px);
            background: white;
            border: 1px solid white;
            border-radius: 10px;
            padding: 15px 12px 10px;
            background: white;
            margin-top: 10px;

            .item {
                margin-top: 20px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .left {
                    width: 80px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                }

                .right {
                    width: calc(95% - 80px);

                    .van-stepper {
                        input {
                            width: 80px;
                        }
                    }

                    .van-cell {
                        padding: 0 0 10px 0;

                        .van-field__value {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }
                    }

                    .van-stepper {
                        button {
                            border: 1px solid #cccccc;
                            background: #fff;
                            border-radius: 14px 0 0 14px;
                        }

                        input {
                            margin: 0;
                            background: #fff;
                            border-top: 1px solid #cccccc;
                            border-bottom: 1px solid #cccccc;
                            width: 50px !important;
                        }

                        .van-stepper__plus {
                            border-radius: 0 14px 14px 0;
                        }
                    }
                }
            }

            .describe-box {
                margin-top: 13px;
                // padding-left: ;
                background: #f9f9f9;
            }

            .title {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
            }
        }

        .efundGoods {
            .title {
                margin-bottom: 15px;
                font-size: 15px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
            }

            .goods-box {
                display: flex;
                justify-content: space-between;

                .left {
                    width: 80px;
                    height: 80px;
                    border: 1px solid transparent;
                    border: none;
                    border-radius: 6px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .right {
                    height: 90px;
                    width: calc(95% - 90px);

                    .title {
                        width: 90%;
                        font-size: 15px;
                        height: 45px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }

                    .contentTxt {
                        width: 90%;
                        margin-top: 10px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        margin-top: 10px;
                        color: #b2b2b2;
                    }
                }
            }

            .item {
                margin-top: 25px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .left {
                    width: 80px;
                }

                .right {
                    width: calc(95% - 80px);

                    .van-stepper {
                        input {
                            width: 80px;
                        }
                    }

                    .van-cell {
                        padding: 0 0 10px 0;
                    }
                }
            }

            .participant {
                .participant-box {
                    padding: 0 16px;

                    .participantItem {
                        width: 100%;
                        height: 40px;
                        margin-top: 10px;
                        line-height: 40px;
                        text-align: center;
                        border: 1px solid rgba(178, 178, 178, 1);
                        border-radius: 5px;
                    }

                    .participantChange {
                        background: rgba(178, 178, 178, 1);
                    }
                }

                .right {
                    border-bottom: 1px solid #f5f5f5;
                }
            }

            .money {
                .right {
                    border-bottom: 1px solid #f5f5f5;
                }
            }
        }

        .service-box {
        }
    }

    .footer {
        width: 100%;
        height: 55px;
        position: fixed;
        bottom: 0;
        background: #fff;

        .content-item {
            height: 55px;
            background: #fff;
            border-top: 1px solid #f5f5f5;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
